import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, message, AutoComplete } from "antd"
import { cuttingLazeError, getMarkInformation } from '../../../services/api/3dApi'

const InputCutLazeError = () => {

    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [error_info, setErrorInfo] = useState('')

    const handleShowModal = async (e) => {
        e.preventDefault()

        const checkValue = /^#\d+_\d+$/.test(valueInput)
        if (!checkValue || !valueInput.trim()) {
            setErrorInput('Item sai định dạng.')
            setIsOpenModal(false)
        } else {
            try {
                const { data: res } = await getMarkInformation(valueInput.trim().replace(/^#/, ''))
                const { data, error, success } = res

                if (!success) return message.error(error)

                const num = valueInput.split('_')[1]
                const itemCutLazed = data.find(i => i.item_number === +num)

                const { batch } = { ...itemCutLazed }
                const { lasers } = { ...batch }

                if (!lasers || !lasers.length) return message.error('Item nằm trong lô chưa được cắt laze.')
                const { finished_at } = { ...lasers[0] }

                if (!finished_at || finished_at === '') return message.error('Item nằm trong lô chưa kết thúc cắt laze.')

                setIsOpenModal(true)

            } catch (error) {
                message.error(error.message)
            }
        }
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const handleChangeError = (value) => {
        setErrorInfo(value)
    }

    const handleCancelModal = () => {
        setIsOpenModal(false)
        setErrorInfo('')
    }

    const _onSubmit = async () => {
        setLoading(true)
        if (!error_info) {
            setLoading(false)
            return message.error('Cần nhập lý do lỗi')
        }

        const payload = {
            barcode: valueInput.trim() || '',
            error_info
        }

        try {
            const { data } = await cuttingLazeError(payload)
            const { success, error } = data

            if (!success) return message.error(error)

            message.success('Đánh dấu cắt lỗi thành công.')
            setIsOpenModal(false)
            setErrorInfo('')
            setValueInput('')
        } catch (error) {
            message.error(error || error.message)
        } finally {
            setLoading(false)
        }
    }

    const _onSubmitEnter = async (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            _onSubmit()
        }
    }

    return (
        <div className="site-layout-background pb-4">
            <div className="MarkCuttingError">
                <div className="MarkCuttingErrorPage">
                    <div className="position-relative">
                        <Spin spinning={loading} tip='Đang kiểm tra...'>
                            <form onSubmit={handleShowModal} className="formQC">
                                <Input
                                    value={valueInput.toUpperCase()}
                                    style={{ fontSize: 40, height: "auto" }}
                                    ref={_input}
                                    autoFocus={true}
                                    placeholder='Nhập item cần đánh dấu lỗi'
                                    onChange={_handleChangeScan}
                                />

                                {
                                    valueInput &&
                                    <Icon
                                        type='close-circle'
                                        className="position-absolute cursor-pointer text-dark IconInput"
                                        onClick={_resetScanInput}
                                    />
                                }

                                {
                                    loading &&
                                    <Icon type="sync" spin className="position-absolute IconInput" />
                                }
                            </form>

                            {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                        </Spin>
                        <Modal title="Đánh dấu cắt lỗi"
                            visible={isOpenModal} closable
                            onCancel={handleCancelModal}
                            wrapClassName="MarkCuttingErrorModal"
                            onOk={_onSubmit}
                        >
                            <Spin spinning={loading} tip='Đang kiểm tra...'>
                                <div className='font-weight-bold'>Nhập vào lý do cắt lỗi:</div>
                                <AutoComplete
                                    options={['Cắt hỏng', 'Cắt thiếu']}
                                    dataSource={['Cắt hỏng', 'Cắt thiếu']}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleChangeError}
                                    allowClear
                                    value={error_info}
                                    className='w-100'
                                    maxLength={20}
                                >
                                    <Input.TextArea
                                        placeholder="Nhập lỗi"
                                        style={{ height: 100 }}
                                        onKeyDown={_onSubmitEnter}
                                    />
                                </AutoComplete>
                            </Spin>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InputCutLazeError